export default "__VITE_ASSET__BYIYgpd5__"